<template>
  <div>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form
          class="ant-advanced-search-form"
          :form="form"
          layout="inline"
          @submit="handleSearch"
        >
          <a-row :gutter="24">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="产品名称">
                <a-input
                  placeholder="请输入产品名称"
                  v-decorator="['fundName']"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="产品代码">
                <a-input
                  placeholder="请输入产品代码"
                  v-decorator="['fundCode']"
                ></a-input>
              </a-form-item>
            </a-col>
            <template v-if="expand">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="分组">
                  <a-select style="width: 120px" v-decorator="['groupType']">
                    <a-select-option
                      v-for="item in groupList"
                      :key="item.productGroupId"
                    >
                      {{ item.productGroupName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="投资类型">
                  <a-select style="width: 120px" v-decorator="['investType']">
                    <a-select-option
                      v-for="item in investType"
                      :key="item.fundInvestTypeId"
                    >
                      {{ item.fundInvestTypeName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleSearch" icon="search"
                  >查询</a-button
                >
                <a-button
                  type="primary"
                  @click="handleReset"
                  icon="reload"
                  style="margin-left: 8px"
                  >重置</a-button
                >
                <a @click="toggle" style="margin-left: 8px">
                  {{ expand ? '收起' : '展开' }}
                  <a-icon :type="expand ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator">
        <!-- <a-button
          type="primary"
          icon="download"
          @click="handleExportExcel('产品基本信息')"
          >导出</a-button
        > -->
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchGroup">
              <a-icon type="tags" />批量分组</a-menu-item
            >
            <a-menu-item key="2" @click="batchConfigure">
              <a-icon type="eye" />批量配置可见内容</a-menu-item
            >
          </a-menu>
          <a-button style="margin-left: 8px">
            批量操作
            <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </div>

      <div class="table">
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
          <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
          >项
          <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        </div>
        <a-table
          bordered
          :columns="columns"
          :data-source="prouuctArr"
          rowKey="fundCode"
          :pagination="ipagination"
          :loading="loading"
          :rowSelection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange
          }"
          @change="handleTableChange"
        >
          <span slot="fundIcon" slot-scope="text">
            <a-tag color="red" v-show="text == 'hot'"> hot </a-tag>
            <a-tag color="blue" v-show="text == 'new'"> new </a-tag>
            <a-tag
              style="
                background: rgba(240, 245, 254);
                border-color: #1890ff;
                color: #1890ff;
              "
              v-show="text == 'good'"
            >
              good
            </a-tag>
          </span>
          <span slot="action" slot-scope="text, record">
            <a @click="handleConfigure(record)">配置可见内容</a>

            <a-divider type="vertical" />
            <a @click="handleGroup(record)">分组</a>
          </span>
        </a-table>
      </div>
      <configure ref="configureModal" @callback="initProductList"></configure>
      <add-group ref="groupModal" @callback="initProductList"></add-group>
    </a-card>
  </div>
</template>
<script>
import {
  getProductDisplayList,
  getInvestType,
  getGroupNameList
} from '@/api/product';
import configure from './configure.vue';
import addGroup from './addGroup.vue';
const columns = [
  {
    title: '产品名称',
    align: 'center',
    dataIndex: 'fundName',
    width: 350,
    ellipsis: true,
    scopedSlots: { customRender: 'fundName' }
  },
  // { title: '产品规模', align: 'center', dataIndex: 'productScale', width: 100 },
  {
    title: '产品代码',
    align: 'center',
    dataIndex: 'fundCode'
  },

  {
    title: '产品分组',
    align: 'center',
    dataIndex: 'fundGroupName'
  },
  {
    title: '投资类型',
    align: 'center',
    dataIndex: 'fundInvestTypeName' //后台没返回 待修改
  },
  {
    title: '图标',
    align: 'center',
    dataIndex: 'fundIcon',
    key: 'fundIcon',
    scopedSlots: {
      customRender: 'fundIcon'
    }
  },

  {
    title: '操作',
    key: 'action',
    align: 'center',
    scopedSlots: { customRender: 'action' }
  }
];
export default {
  data() {
    return {
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      columns,
      expand: false, //搜索展开收起
      form: this.$form.createForm(this),
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      loading: false,
      prouuctArr: [],
      selectedRowKeys: [],
      investType: [],
      groupList: []
    };
  },
  components: {
    configure,
    addGroup
  },
  created() {
    this.initProductList();
    this.initInvestType();
    this.initGroupList();
  },
  methods: {
    //搜索
    handleSearch(e) {
      e.preventDefault();
      this.initProductList(1);
    },
    //切换搜索
    toggle() {
      this.expand = !this.expand;
    },
    //重置
    handleReset() {
      this.form.resetFields();
      this.initProductList(1);
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },

    //table数据
    initProductList() {
      let that = this;
      that.prouuctArr = [];
      this.onClearSelected();
      this.form.validateFields((error, values) => {
        let params = {
          ...values,
          pageNo: this.ipagination.current,
          pageSize: this.ipagination.pageSize
        };
        that.loading = true;
        //临时接口 记得更换
        getProductDisplayList(params)
          .then(res => {
            that.loading = false;
            if (res.success) {
              that.prouuctArr =
                res.result && res.result.list ? res.result.list : [];
              that.loading = false;
              that.ipagination.total = res.result.total;
            }
          })
          .finally(() => {
            that.loading = false;
          });
      });
    },
    initInvestType() {
      getInvestType().then(res => {
        if (res.success) {
          this.investType = res.result ? res.result : [];
        } else {
          this.$message.error(res.message);
        }
      });
    },
    initGroupList() {
      getGroupNameList().then(res => {
        console.log('res1231', res);
        if (res.success) {
          this.groupList = res.result ? res.result : [];
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRows = selectionRows;
      this.selectedRowKeys = selectedRowKeys;
      console.log(selectionRows);
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected();
      this.ipagination = pagination;
      this.initProductList();
    },
    batchConfigure() {
      this.$refs.configureModal.handleVisible();
      this.$refs.configureModal.bathInitConfigure(this.selectedRowKeys);
    },
    handleConfigure(record) {
      this.$refs.configureModal.handleVisible(record);
      this.$refs.configureModal.initConfigure(record.fundCode);
    },
    batchGroup() {
      this.$refs.groupModal.handleVisible();
      this.$refs.groupModal.initGroupList(this.selectedRowKeys);
    },
    handleGroup(records) {
      this.$refs.groupModal.groupId = records.fundGroupId;
      this.$refs.groupModal.handleVisible();
      this.$refs.groupModal.initGroupList(records.fundCode);
    }
  }
};
</script>
<style scoped>
.table-operator {
  margin-bottom: 10px;
}
.table-operator .ant-btn {
  margin-right: 10px;
}
</style>
